export const DETAILS_SECTION = "details";

export default {
    DETAILS_SECTION,
};
